import { useOidc } from '@axa-fr/react-oidc';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Hero } from './Hero';
import { Loading } from './Loading';
import { ContentBlock } from './Content/ContentBlock';
import { ContentBody } from './Content/ContentBody';


export const PermissionsRequired = (props: { showParticipantMsg?: boolean }) => {
    const { login, isAuthenticated } = useOidc();
    const navigate = useNavigate();

    useEffect(() => {
        if (props.showParticipantMsg) {
            navigate('/Home/403');
        }
    }, []);


    return (
        <>

            {!isAuthenticated && !props.showParticipantMsg && (
                <div className="loadingPage">
                    <Hero pageTitle="   " />
                    <ContentBlock className="loadingScreen">
                        <ContentBody>
                            <Col className="text-align-center align-content-center">
                                You must be logged in to view this content.&nbsp;&nbsp;&nbsp;
                                <Button name="LoginButton" className="submitButton solidNeg primaryButton iconRightArrow" onClick={() => login("/Login")}>Login</Button>
                            </Col>
                        </ContentBody>
                    </ContentBlock>
                </div >
            )}
            {props.showParticipantMsg && (
                <Loading showContent={true} includeHero={true} key='permissionsPage' />
            )}

        </>
    );
};